import { WebGLNotSupportedEventAdapter } from 'app/student/game-section/analytics/events/webgl-not-supported.event-adapter';
import { KhAnalyticsService } from '../services/kh-analytics.service';

export function checkWebGLSupport(khAnalyticsService: KhAnalyticsService): boolean {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
  const isWebGLSupported = !!(window.WebGLRenderingContext && gl);
  if (!isWebGLSupported) {
    console.error('WebGL is not supported');
    khAnalyticsService.trackEvent(new WebGLNotSupportedEventAdapter().prepareEvent());
  }

  // Clean up the context
  (gl as WebGLRenderingContext)?.getExtension('WEBGL_lose_context')?.loseContext();
  canvas.width = 0;
  canvas.height = 0;

  return isWebGLSupported;
}
